// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * ForwardModal Styles
 * Pixel-perfect implementation based on Figma design
 */

/* Overlay */
.forward-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  box-sizing: border-box;
}

/* Modal Container */
.forward-modal {
  background: #FFFFFF;
  border-radius: 20px;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.12);
  width: 731px;
  max-width: 90vw;
  height: 902px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  font-family: 'Open Sans', sans-serif;
  overflow: hidden;
}

/* Header */
.forward-modal-header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 24px 16px 24px;
  position: relative;
}

.forward-modal-title {
  margin: 0;
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 27px;
  font-weight: 700;
  line-height: 100%;
  letter-spacing: 0;
  color: #2E2E2E;
  text-align: center;
}

.forward-modal-close {
  position: absolute;
  right: 15px;
  top: 15px;
  background: #4A4A4A;
  border: none;
  font-size: 20px;
  color: #FFFFFF;
  cursor: pointer;
  padding: 0;
  border-radius: 50%;
  transition: background 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  line-height: 1;
}

.forward-modal-close:hover {
  background: #333333;
}

/* Limit Error Message */
.forward-modal-limit-error {
  background: #FEE;
  color: #DE4858;
  padding: 12px 24px;
  margin: 16px 24px;
  border-radius: 8px;
  border: 1px solid #DE4858;
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
}

/* Search Bar */
.forward-modal-search {
  padding: 0 24px 16px 24px;
}

.forward-modal-search-container {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #FFFFFF;
  border: 2px solid #CDCCCD;
  border-radius: 8px;
  height: 44px;
  padding: 10px 20px;
}

.forward-modal-search-icon {
  font-size: 18px;
  color: #9B9B9B;
}

.forward-modal-search-input {
  flex: 1;
  border: none;
  outline: none;
  font-family: 'Open Sans', sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 1.36em;
  color: #000000;
  background: transparent;
}

.forward-modal-search-input::placeholder {
  color: #9B9B9B;
}

.forward-modal-search-clear {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9B9B9B;
  font-size: 20px;
  transition: color 0.2s;
  line-height: 1;
}

.forward-modal-search-clear:hover {
  color: #4A4A4A;
}

/* Tabs */
.forward-modal-tabs {
  display: flex;
  align-items: center;
  gap: 25px;
  padding: 0 24px;
  border-bottom: 1px solid #E5E5E5;
}

.forward-modal-tabs-left {
  display: flex;
  gap: 25px;
}

.forward-modal-tabs-right {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 12px;
}

.forward-modal-tabs-counter {
  font-family: 'SF Pro Text', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.5%;
  color: #000000;
  transition: color 0.2s ease;
}

.forward-modal-tabs-counter.limit-reached {
  color: #DE4858;
}

.forward-modal-tabs-counter.shake {
  animation: shake 0.5s ease-in-out;
}

.forward-modal-clear-all {
  background: none;
  border: none;
  font-family: 'SF Pro Text', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #DE4858;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.15s ease;
}

.forward-modal-clear-all:hover {
  background-color: rgba(222, 72, 88, 0.1);
}

.forward-modal-clear-all:active {
  background-color: rgba(222, 72, 88, 0.2);
}

@keyframes shake {
  0%, 100% {
    transform: translateX(0);
  }
  10%, 30%, 50%, 70%, 90% {
    transform: translateX(-5px);
  }
  20%, 40%, 60%, 80% {
    transform: translateX(5px);
  }
}

.forward-modal-tab {
  background: none;
  border: none;
  font-family: 'Roboto', sans-serif;
  font-size: 18px;
  font-weight: 500;
  line-height: 100%;
  letter-spacing: 0;
  color: #4A4A4A;
  padding: 12px 0;
  cursor: pointer;
  position: relative;
  transition: color 0.15s ease;
}

.forward-modal-tab:hover {
  color: #4A4A4A;
}

.forward-modal-tab.active {
  font-weight: 700;
  color: #4A4A4A;
}

.forward-modal-tab.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #DE4858;
}

/* Conversation List */
.forward-modal-list {
  flex: 1;
  overflow-y: auto;
}

.forward-modal-loading,
.forward-modal-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 200px;
  color: #9B9B9B;
  font-size: 16px;
}

/* Action Buttons */
.forward-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  padding: 20px 24px 24px 24px;
  border-top: 1px solid #E5E5E5;
}

.forward-modal-btn {
  font-family: 'Open Sans', sans-serif;
  font-size: 18px;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: 0;
  height: 45px;
  padding: 10px 24px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.15s ease;
  min-width: 100px;
}

.forward-modal-btn-cancel {
  background: #D8D8D8;
  color: #6A6A6A;
  border: none;
}

.forward-modal-btn-cancel:hover:not(:disabled) {
  background-color: #CDCCCD;
}

.forward-modal-btn-forward {
  background: #DE4858;
  color: #FFFFFF;
  border: none;
}

.forward-modal-btn-forward:hover:not(:disabled) {
  background: #C83E4E;
}

.forward-modal-btn-forward:disabled {
  background: #CDCCCD;
  cursor: not-allowed;
}

.forward-modal-btn-cancel:disabled {
  background: #E8E8E8;
  color: #AAAAAA;
  cursor: not-allowed;
}

/* Responsive Design */
@media (max-width: 480px) {
  .forward-modal {
    width: 100%;
    max-height: 80vh;
    border-radius: 20px 20px 0 0;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .forward-modal-overlay {
    align-items: flex-end;
    padding: 0;
  }

  .forward-modal-title {
    font-size: 22px;
  }

  .forward-modal-actions {
    flex-direction: column-reverse;
  }

  .forward-modal-btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Modal/ForwardModal.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,YAAY;AACZ;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,4CAA4C;EAC5C,YAAY;EACZ,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,4EAA4E;EAC5E,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,yEAAyE;EACzE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,yEAAyE;EACzE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,4BAA4B;IAC5B,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;EACV;;EAEA;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/**\n * ForwardModal Styles\n * Pixel-perfect implementation based on Figma design\n */\n\n/* Overlay */\n.forward-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n/* Modal Container */\n.forward-modal {\n  background: #FFFFFF;\n  border-radius: 20px;\n  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.12);\n  width: 731px;\n  max-width: 90vw;\n  height: 902px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  font-family: 'Open Sans', sans-serif;\n  overflow: hidden;\n}\n\n/* Header */\n.forward-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px 24px 16px 24px;\n  position: relative;\n}\n\n.forward-modal-title {\n  margin: 0;\n  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 27px;\n  font-weight: 700;\n  line-height: 100%;\n  letter-spacing: 0;\n  color: #2E2E2E;\n  text-align: center;\n}\n\n.forward-modal-close {\n  position: absolute;\n  right: 15px;\n  top: 15px;\n  background: #4A4A4A;\n  border: none;\n  font-size: 20px;\n  color: #FFFFFF;\n  cursor: pointer;\n  padding: 0;\n  border-radius: 50%;\n  transition: background 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  line-height: 1;\n}\n\n.forward-modal-close:hover {\n  background: #333333;\n}\n\n/* Limit Error Message */\n.forward-modal-limit-error {\n  background: #FEE;\n  color: #DE4858;\n  padding: 12px 24px;\n  margin: 16px 24px;\n  border-radius: 8px;\n  border: 1px solid #DE4858;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  text-align: center;\n}\n\n/* Search Bar */\n.forward-modal-search {\n  padding: 0 24px 16px 24px;\n}\n\n.forward-modal-search-container {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: #FFFFFF;\n  border: 2px solid #CDCCCD;\n  border-radius: 8px;\n  height: 44px;\n  padding: 10px 20px;\n}\n\n.forward-modal-search-icon {\n  font-size: 18px;\n  color: #9B9B9B;\n}\n\n.forward-modal-search-input {\n  flex: 1;\n  border: none;\n  outline: none;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 18px;\n  font-weight: 400;\n  line-height: 1.36em;\n  color: #000000;\n  background: transparent;\n}\n\n.forward-modal-search-input::placeholder {\n  color: #9B9B9B;\n}\n\n.forward-modal-search-clear {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #9B9B9B;\n  font-size: 20px;\n  transition: color 0.2s;\n  line-height: 1;\n}\n\n.forward-modal-search-clear:hover {\n  color: #4A4A4A;\n}\n\n/* Tabs */\n.forward-modal-tabs {\n  display: flex;\n  align-items: center;\n  gap: 25px;\n  padding: 0 24px;\n  border-bottom: 1px solid #E5E5E5;\n}\n\n.forward-modal-tabs-left {\n  display: flex;\n  gap: 25px;\n}\n\n.forward-modal-tabs-right {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.forward-modal-tabs-counter {\n  font-family: 'SF Pro Text', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 20px;\n  letter-spacing: -0.5%;\n  color: #000000;\n  transition: color 0.2s ease;\n}\n\n.forward-modal-tabs-counter.limit-reached {\n  color: #DE4858;\n}\n\n.forward-modal-tabs-counter.shake {\n  animation: shake 0.5s ease-in-out;\n}\n\n.forward-modal-clear-all {\n  background: none;\n  border: none;\n  font-family: 'SF Pro Text', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  color: #DE4858;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n  transition: all 0.15s ease;\n}\n\n.forward-modal-clear-all:hover {\n  background-color: rgba(222, 72, 88, 0.1);\n}\n\n.forward-modal-clear-all:active {\n  background-color: rgba(222, 72, 88, 0.2);\n}\n\n@keyframes shake {\n  0%, 100% {\n    transform: translateX(0);\n  }\n  10%, 30%, 50%, 70%, 90% {\n    transform: translateX(-5px);\n  }\n  20%, 40%, 60%, 80% {\n    transform: translateX(5px);\n  }\n}\n\n.forward-modal-tab {\n  background: none;\n  border: none;\n  font-family: 'Roboto', sans-serif;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 100%;\n  letter-spacing: 0;\n  color: #4A4A4A;\n  padding: 12px 0;\n  cursor: pointer;\n  position: relative;\n  transition: color 0.15s ease;\n}\n\n.forward-modal-tab:hover {\n  color: #4A4A4A;\n}\n\n.forward-modal-tab.active {\n  font-weight: 700;\n  color: #4A4A4A;\n}\n\n.forward-modal-tab.active::after {\n  content: '';\n  position: absolute;\n  bottom: -1px;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background-color: #DE4858;\n}\n\n/* Conversation List */\n.forward-modal-list {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.forward-modal-loading,\n.forward-modal-empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  min-height: 200px;\n  color: #9B9B9B;\n  font-size: 16px;\n}\n\n/* Action Buttons */\n.forward-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 15px;\n  padding: 20px 24px 24px 24px;\n  border-top: 1px solid #E5E5E5;\n}\n\n.forward-modal-btn {\n  font-family: 'Open Sans', sans-serif;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 100%;\n  letter-spacing: 0;\n  height: 45px;\n  padding: 10px 24px;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  min-width: 100px;\n}\n\n.forward-modal-btn-cancel {\n  background: #D8D8D8;\n  color: #6A6A6A;\n  border: none;\n}\n\n.forward-modal-btn-cancel:hover:not(:disabled) {\n  background-color: #CDCCCD;\n}\n\n.forward-modal-btn-forward {\n  background: #DE4858;\n  color: #FFFFFF;\n  border: none;\n}\n\n.forward-modal-btn-forward:hover:not(:disabled) {\n  background: #C83E4E;\n}\n\n.forward-modal-btn-forward:disabled {\n  background: #CDCCCD;\n  cursor: not-allowed;\n}\n\n.forward-modal-btn-cancel:disabled {\n  background: #E8E8E8;\n  color: #AAAAAA;\n  cursor: not-allowed;\n}\n\n/* Responsive Design */\n@media (max-width: 480px) {\n  .forward-modal {\n    width: 100%;\n    max-height: 80vh;\n    border-radius: 20px 20px 0 0;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n  }\n\n  .forward-modal-overlay {\n    align-items: flex-end;\n    padding: 0;\n  }\n\n  .forward-modal-title {\n    font-size: 22px;\n  }\n\n  .forward-modal-actions {\n    flex-direction: column-reverse;\n  }\n\n  .forward-modal-btn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
